import React from "react";
import useModalNeedHelp from "../../Modals/useModalNeedHelp";

const Hints = ({link}) =>
{
    const [ renderNeedHelp, activateNeedHelp ] = useModalNeedHelp((result) =>
    {

    })

    const clickNeedHelp = () =>
    {
        activateNeedHelp({mode: 'view'}) ;
    }

    const linkText = link === "forgotpassword.php" ? "Forgot Password?" : "Back to Login";

    return (
        <div>
            <a href={link} className="forgot_link no-padding-left">{linkText}</a>
            <a className="forgot_link no-padding-right" onClick={clickNeedHelp}>Need help?</a>
            { renderNeedHelp() }
        </div>

    )

}
export default Hints ;